import script from "./UnemployedDetails.vue?vue&type=script&setup=true&lang=js"
export * from "./UnemployedDetails.vue?vue&type=script&setup=true&lang=js"

import "./UnemployedDetails.vue?vue&type=style&index=0&id=db0f5bbe&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-db0f5bbe"]])

export default __exports__